import { GroupedPastIncidentsType } from "@pages/status-page/helpers/pastIncidents";
import { ApiIncidentType } from "@store/types";
import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import { Incident } from "./Incident";
import { tw } from "@noones/ui/tw";
import { formatDateUTC } from "@pages/status-page/helpers/formatDate";

export type IncidentTimelineProps = {
    incidents: ApiIncidentType[];
    groupedIncidents: GroupedPastIncidentsType | false;
};

export const IncidentTimeline = ({ groupedIncidents }: IncidentTimelineProps) => (
    <div className={tw.space_y_4}>
        {groupedIncidents &&
            Object.keys(groupedIncidents).map((date) => (
                <div key={date}>
                    <div className={tw.my_2}>
                        {Object.values(groupedIncidents[date]).map((incident) => (
                            <div key={incident.id} className={tw.my_3.bg_white.p_4.rounded_xl}>
                                <div className={tw.text_green.text_h4.font_semibold}>
                                    {incident.name}
                                </div>

                                <Incident incident_updates={incident.incident_updates} />
                            </div>
                        ))}
                    </div>

                    {!groupedIncidents[date].length && (
                        <div className={tw.rounded_xl.bg_white.p_4}>
                            <div className={tw.mb_3}>
                                <div className={tw.text_body_12.font_normal.text_black.shrink_0}>
                                    {formatDateUTC(date)}
                                </div>
                            </div>
                            <div className={tw.text_grey_green_text.font_normal.text_body_14}>
                                <FormattedMessage {...messages.defaultText} />
                            </div>
                        </div>
                    )}
                </div>
            ))}
    </div>
);

const messages = defineMessages({
    defaultText: {
        id: "IncidentTimeLine.text",
        defaultMessage: "No incidents reported today.",
        description: "No incidents reported text",
    },
});
